import React, { useState } from 'react'
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  makeStyles,
  IconButton,
  TextField,
  Typography,
  useTheme,
  withStyles
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useDispatch } from 'react-redux';
import { actions } from '../../../../store/ducks/general.duck';
import {
  PortletBody,
} from '../../../../../app/partials/content/Portlet';
import './ModalReportsSaved.scss';
import { GetTranslatedValue } from '../../utils';

const DialogContent5 = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    height: '120px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}))(DialogContent);

const DialogTitle5 = withStyles(styles5)(({ children, classes, onClose }) => {
  return (
    <DialogTitle
      disableTypography
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '500px' }}
    >
      <Typography variant='h6'>{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label='Close'
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
});

const styles5 = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    border: '10px solid red'
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  }
});

const DialogActions5 = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1)
  }
}))(DialogActions);

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200
  },
  dense: {
    marginTop: 19
  },
  menu: {
    width: 200
  },
  button: {
    display: 'block',
    marginTop: theme.spacing(2)
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120
  }
}));

const SaveReportModal = ({
  saveData,
  setShowModal,
  showModal
}) => {
  const dispatch = useDispatch();
  const { showCustomAlert } = actions;
  const [renameReport, setRenameReport] = useState('');

  const handleChangeName = (e) => {
    const { value } = e.target;
    setRenameReport(value);
  }

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleSave = () => {
    if (renameReport.trim() === '') {
      dispatch(
        showCustomAlert({
          open: true,
          message: 'Please enter a valid name...',
          type: 'warning'
        })
      );
    } else {
      saveData(renameReport);
      handleCloseModal();
    }
  }

  return (
    <div style={{ width: '100px' }}>
      <Dialog
        aria-labelledby='customized-dialog-title'
        onClose={handleCloseModal}
        open={showModal}
      >
        <DialogTitle5 id='customized-dialog-title' onClose={handleCloseModal}>
          {GetTranslatedValue('REPORTS.SAVE.REPORT', 'Save Report')}
        </DialogTitle5>
        <DialogContent5 dividers>
          <PortletBody>
            <TextField
              onChange={handleChangeName}
              placeholder={GetTranslatedValue('RECORD.CAPTION.NAME', 'Name')}
              style={{ width: '200px' }}
            />
          </PortletBody>
        </DialogContent5>
        <DialogActions5>
          <Button color='primary' onClick={handleSave}>
            {GetTranslatedValue('GENERAL.CAPTION.SAVE.CHANGES', 'Save Changes')}
          </Button>
        </DialogActions5>
      </Dialog>
    </div>
  )
}

export default SaveReportModal;
